import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Backdrop,
  Stack,
  Typography,
  LinearProgress
} from '@mui/material';
import {AlertSettingsBasic} from './AlertSettingsBasic.tsx';
import {useAlertSettingsDialog} from '../hooks/useAlertSettingsDialog.tsx';

interface AlertSettingsWizardDialogProps {
  open: boolean;
  onClose: () => void;
  alertId: string;
  reload: () => Promise<void>;
  devices: any[];
  emails: any[];
  onSaveAndOpenNotification?: (newAlertId: string) => void;
}

export const AlertSettingsWizardDialog = ({
  open,
  onClose,
  alertId,
  reload,
  devices,
  emails,
  onSaveAndOpenNotification
}: AlertSettingsWizardDialogProps) => {
  const {
    onSubmit,
    active,
    setActive,
    alertName,
    machine,
    rule,
    setRule,
    processType,
    setProcessType,
    scheduleType,
    from,
    to,
    fixTime,
    isPdf,
    setIsPdf,
    DAYS_MAP,
    days,
    setDays,
    interval,
    disabled,
    isLoading,
    t,
    validationErrors,
    handleAlertNameChange,
    handleMachineChange,
    handleFromChange,
    handleToChange,
    handleFixTimeChange,
    handleIntervalChange,
    handleScheduleTypeChange
  } = useAlertSettingsDialog({
    onClose,
    alertId,
    open,
    reload,
    devices,
    emails,
    onSaveAndOpenNotification
  });

  // 保存してダイアログを閉じる
  const handleSaveOnly = async () => {
    await onSubmit(false); // false = 通知先設定を開かない
  };

  // 保存して通知先設定を開く
  const handleSaveAndOpenNotification = async () => {
    await onSubmit(true); // true = 通知先設定を開く
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <Typography variant="h6">{t('アラート設定 : 新規作成')}</Typography>
      </DialogTitle>

      {isLoading && (
        <Backdrop sx={{zIndex: 9999}} open={true}>
          <Stack sx={{width: '50%'}} spacing={2} textAlign={'center'}>
            <Typography variant="h4" color="secondary">
              Loading..
            </Typography>
            <LinearProgress color="secondary" />
          </Stack>
        </Backdrop>
      )}

      <DialogContent>
        <AlertSettingsBasic
          active={active}
          setActive={setActive}
          alertName={alertName}
          machine={machine}
          processType={processType}
          setProcessType={setProcessType}
          rule={rule}
          setRule={setRule}
          scheduleType={scheduleType}
          days={days}
          setDays={setDays}
          from={from}
          to={to}
          fixTime={fixTime}
          interval={interval}
          isPdf={isPdf}
          setIsPdf={setIsPdf}
          devices={devices}
          DAYS_MAP={DAYS_MAP}
          t={t}
          validationErrors={validationErrors}
          handleAlertNameChange={handleAlertNameChange}
          handleMachineChange={handleMachineChange}
          handleFromChange={handleFromChange}
          handleToChange={handleToChange}
          handleFixTimeChange={handleFixTimeChange}
          handleIntervalChange={handleIntervalChange}
          handleScheduleTypeChange={handleScheduleTypeChange}
        />
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'space-between',
          padding: 2,
          gap: 2
        }}
      >
        <div style={{display: 'flex', gap: 12}}>
          <Button variant="contained" color="primary" onClick={handleSaveOnly} disabled={disabled}>
            {t('設定の保存')}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSaveAndOpenNotification}
            disabled={disabled}
          >
            {t('保存して通知先設定へ')}
          </Button>
        </div>

        <Button variant="outlined" color="primary" onClick={onClose}>
          {t('キャンセル')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
